import { TLang } from 'src/constants/langs'
import { LocalizedText } from 'src/types/common/localized'
import { getLocalizedText } from '../getLocalizedText'

export function useLocalizedText(
    lang: TLang,
    texts: Record<TLang, LocalizedText>
): LocalizedText {
    return getLocalizedText(lang, texts)
}
